import React from 'react'
import PropTypes from 'prop-types'
import {GridCell as RmwcGridCell} from '@rmwc/grid'
import '@rmwc/grid/styles'

const GridCell = ({children, ...otherProps}) => <RmwcGridCell {...otherProps}>{children}</RmwcGridCell>

GridCell.propTypes = {
  children: PropTypes.any
}

export {GridCell}
